import React, {useCallback, useRef} from 'react';
import {Icon} from '@bonprix/design-system';
import {addToClickedFilters, fillInitialClickedFilters} from '../../helper/filter-helper';
import {yieldToMain} from '../../ArticleOverviewHelper';

const DARK_SWATCH_VALUES = new Set(['1', '3', '8', '23', '36', '61', '127']);

function getCheckIconClassName(colorValue) {
    return DARK_SWATCH_VALUES.has(String(colorValue)) ? 'fill-clr-primary-inverse' : 'fill-clr-primary';
}

function ColorOption({option, isSelected, onClick}) {

    const handleClick = (event) => {
        event.preventDefault();
        onClick(event, option);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            onClick(event, option);
        }
    };

    const commonProps = {
        className: `filter__color-button color color-${option.value} ${isSelected ? 'is-selected' : ''}`,
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        role: 'checkbox',
        'aria-checked': isSelected,
        'aria-label': option.label || option.value,
        tabIndex: 0,
    };

    const checkIcon = isSelected ? <Icon variant="check" className={getCheckIconClassName(option.value)} /> : null;

    return (
        <div className="filter__option -color">
            <div className="filter__color-input-label">
                {option.seoHref ? (
                    <a {...commonProps} href={option.seoHref}>
                        {checkIcon}
                    </a>
                ) : (
                    <div {...commonProps}>
                        {checkIcon}
                    </div>
                )}
            </div>
        </div>
    );
}

function Color({filterOptionChange, identifier, trackingId, filterOptions}) {
    const clickedFilters = useRef(fillInitialClickedFilters(filterOptions));

    const handleClick = useCallback((event, option) => {
        clickedFilters.current = addToClickedFilters(option.value, clickedFilters.current);
        yieldToMain(() => filterOptionChange(identifier, trackingId, clickedFilters.current));
    }, [filterOptionChange, identifier, trackingId]);

    return (
        <div className="filter__color">
            {filterOptions.map((option) => (
                <ColorOption
                    key={option.value}
                    option={option}
                    isSelected={clickedFilters.current.includes(option.value)}
                    onClick={handleClick}
                />
            ))}
        </div>
    );
}

export default React.memo(Color);
